import './UserRegister.scss'
import { FaFacebook, FaTwitter } from "react-icons/fa6";
import { FaGoogle } from "react-icons/fa";
import React from 'react';
import { useFormik } from 'formik'
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios'
import { toast } from 'react-toastify'
// import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";

const GoogleLoginButton = () => {
    const handleLogin = () => {
        window.location.href = "http://localhost:3010/auth/google";
    };

    return <FaGoogle onClick={handleLogin} className="icon ms-4 fs-3" />;
};

const UserRegister = () => {

    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            user_fName: "",
            user_lName: "",
            user_email: "",
            user_moNo: "",
            user_pass: "",
            user_conf_pass: "",
            user_Img: null,
            user_area: "",
            user_city: "",
            user_state: "",
            user_country: "",
            user_gender: ""
        },
        validate: (values) => {
            const errors = {};

            if (!values.user_fName) {
                errors.user_fName = "Please Enter Valid User Name";
            } else if (!/^[a-zA-Z ]+$/.test(values.user_fName)) {
                errors.user_fName = "Name should only contain letters and Spaces";
            }

            if (!values.user_lName) {
                errors.user_lName = "Please Enter Valid User Name";
            } else if (!/^[a-zA-Z ]+$/.test(values.user_lName)) {
                errors.user_lName = "Name should only contain letters and Spaces";
            }

            if (values.user_email) {
                if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.user_email)) {
                    errors.user_email = "Please Enter Valid email Address";
                }
            } else {
                errors.user_email = "Invalid email address";
            }

            if (!values.user_moNo.trim()) {
                errors.user_moNo = "Please enter a valid mobile number.";
            } else if (!/^[6-9]\d{9}$/.test(values.user_moNo)) {
                errors.user_moNo = "Mobile number must start with 6-9 and contain exactly 10 digits.";
            } else if (values.user_moNo.length !== 10) {
                errors.user_moNo = "Mobile number must be exactly 10 digits.";
            } else if (/\D/.test(values.user_moNo)) {
                errors.user_moNo = "Only numbers are allowed.";
            }


            if (!values.user_pass) {
                errors.user_pass = "Please Enter Password";
            } else if (values.user_pass.length < 8) {
                errors.user_pass = "Password should be at least 8 characters long";
            } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/.test(values.user_pass)) {
                errors.user_pass = "Password should contain at least one uppercase letter, one lowercase letter, one digit, and one special character (!@#$%^&*)";
            }


            if (!values.user_conf_pass) {
                errors.user_conf_pass = "Please confirm your password";
            } else if (values.user_conf_pass !== values.user_pass) {
                errors.user_conf_pass = "Passwords do not match";
            }
            if (!values.user_Img) {
                errors.user_Img = "Please upload an image";
            }

            // Role validation
            if (!values.user_gender) {
                errors.user_gender = "Please select a valid gender";
            }
            if (!values.user_area) {
                errors.user_area = "Please select a valid gender";
            }
            if (!values.user_city) {
                errors.user_city = "Please select a valid મગૂબ";
            }
            if (!values.user_state) {
                errors.user_state = "Please select a valid state";
            }
            if (!values.user_country) {
                errors.user_country = "Please select a valid country";
            }

            return errors;
        },

        onSubmit: async (values) => {
            console.log(values);
            const formData = new FormData();

            // Ensure user_img is a valid File
            if (values.user_Img && values.user_Img instanceof File) {
                const file = values.user_Img;
                const fileExtension = file.name.split('.').pop(); // Extract extension
                const randomFileName = `${Date.now()}_${Math.random().toString(36).substring(2, 10)}.${fileExtension}`;

                // Create a new File instance
                const modifiedFile = new File([file.slice(0, file.size)], randomFileName, { type: file.type });

                console.log("Modified File Name:", modifiedFile.name);

                // Alternative Method: Use set() instead of append()
                formData.set("user_Img", modifiedFile);
            } else {
                console.error("user_img is not a valid File object:", values.user_Img);
            }

            // Append other form 
            const formEntries = {
                user_fName: values.user_fName || "",
                user_lName: values.user_lName || "",
                user_email: values.user_email || "",
                user_moNo: values.user_moNo || "",
                user_pass: values.user_pass || "",
                user_conf_pass: values.user_conf_pass || "",
                user_gender: values.user_gender || "",
                user_area: values.user_area || "",
                user_city: values.user_city || "",
                user_state: values.user_state || "",
                user_country: values.user_country || "",
            };

            // Alternative Method: Use `forEach` to append values
            Object.entries(formEntries).forEach(([key, value]) => {
                formData.append(key, value);
            });

            // Correct way to debug FormData
            console.log("FormData Debugging:", formData);
            for (let [key, value] of formData.entries()) {
                console.log(`${key}:`, value);
            }

            // ✅ Send FormData via Axios
            axios.post('http://localhost:3010/user/userRegister', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then(response => {
                console.log("Response:", response);
                if (response.data.token) {
                    localStorage.setItem("userToken", response.data.token);
                    console.log('Token stored successfully!');
                }
                navigate('/userLogin');
                toast.success("Registration Successful");
            }).catch(error => {
                console.error('Error:', error);
                alert(error.response ? error.response.data.message : "Registration Failed. Please try again.");
                toast.error("Registration Failed");
            });

        }
    })

    return (
        <>
            <div className="conatiner-lg container-fluid banner mt-5">
                <div className="row signin m-0">
                    <div className='text-white mt-5 ps-5'>
                        <a href='/user/home' className='text-white text-decoration-none'><h6 className=''>Home &nbsp; / &nbsp; Register</h6></a>
                        <h3 className='text-white'> Register</h3>
                    </div>
                </div>

                <div className="container register-form mb-5">
                    <div className="row justify-content-center ">
                        <div className="box row p-3 mt-5 border border-secondary-subtle rounded">
                            <div className='d-flex justify-content-center'>
                                <h2>Register Here</h2>
                            </div>

                            <form method='post' onSubmit={formik.handleSubmit}>
                                <div className="row mt-4 my-4">
                                    <div className="col-md-6 col-12 ">
                                        <label htmlFor="">First Name </label>
                                        <input type="text" name='user_fName' value={formik.values.user_fName} onChange={formik.handleChange} onBlur={formik.handleBlur} className='w-100 form-control mt-2 shadow-none' placeholder='First Name' />
                                        {formik.touched.user_fName && formik.errors.user_fName ? (
                                            <p className="text-danger">{formik.errors.user_fName}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <label htmlFor="">Last Name </label>
                                        <input type="text" name='user_lName' value={formik.values.user_lName} onChange={formik.handleChange} onBlur={formik.handleBlur} className='w-100 form-control shadow-none mt-2' placeholder='Last Name' />
                                        {formik.touched.user_lName && formik.errors.user_lName ? (
                                            <p className="text-danger">{formik.errors.user_lName}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12 mt-3">
                                        <label htmlFor="">Email </label>
                                        <input type="email" name='user_email' value={formik.values.user_email} onChange={formik.handleChange} onBlur={formik.handleBlur} className='w-100 form-control shadow-none mt-2' placeholder='Enter Email' />
                                        {formik.touched.user_email && formik.errors.user_email ? (
                                            <p className="text-danger">{formik.errors.user_email}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12 mt-3">
                                        <label htmlFor="">Mobile No </label>
                                        <input type="text" name='user_moNo' value={formik.values.user_moNo} onChange={formik.handleChange} onBlur={formik.handleBlur} className='w-100 form-control shadow-none mt-2' placeholder='Mobile Number' />
                                        {formik.touched.user_moNo && formik.errors.user_moNo ? (
                                            <p className="text-danger">{formik.errors.user_moNo}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12 mt-3">
                                        <label htmlFor="">Password </label>
                                        <input type="password" name='user_pass' value={formik.values.user_pass} onChange={formik.handleChange} onBlur={formik.handleBlur} className='w-100 form-control shadow-none mt-2' placeholder='Password' />
                                        {formik.touched.user_pass && formik.errors.user_pass ? (
                                            <p className="text-danger">{formik.errors.user_pass}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12 mt-3">
                                        <label>Confirm Password</label>
                                        <input type="password" name="user_conf_pass" value={formik.values.user_conf_pass} onChange={formik.handleChange} onBlur={formik.handleBlur} className="w-100 form-control shadow-none mt-2" placeholder="Re-Enter Password" />
                                        {formik.touched.user_conf_pass && formik.errors.user_conf_pass ? (
                                            <p className="text-danger">{formik.errors.user_conf_pass}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12 mt-3">
                                        <label htmlFor="">Image </label>
                                        {/* <input type="file" name='user_img' value={formik.values.user_img} onChange={formik.handleChange}  /> */}
                                        <input
                                            type="file"
                                            name="user_Img"
                                            onChange={(event) => {
                                                formik.setFieldValue("user_Img", event.currentTarget.files[0]); // Set file properly
                                            }} onBlur={formik.handleBlur}
                                            className="w-100 form-control shadow-none mt-2"

                                        />

                                        {formik.touched.user_Img && formik.errors.user_Img ? (
                                            <p className="text-danger">{formik.errors.user_Img}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12 mt-3">
                                        <label htmlFor="gender">Gender</label>
                                        <div className="mt-2">
                                            <input
                                                type="radio"
                                                name="user_gender"
                                                value="Male"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                checked={formik.values.user_gender === "Male"}
                                            />
                                            <label className="ms-2">Male</label>

                                            <input
                                                type="radio"
                                                name="user_gender"
                                                value="Female"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                checked={formik.values.user_gender === "Female"}
                                                className="ms-3"
                                            />
                                            <label className="ms-2">Female</label>

                                            <input
                                                type="radio"
                                                name="gender"
                                                value="Other"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                checked={formik.values.gender === "other"}
                                                className="ms-3"
                                            />
                                            <label className="ms-2">Other</label>
                                        </div>

                                        {formik.touched.gender && formik.errors.gender ? (
                                            <p className="text-danger">{formik.errors.gender}</p>
                                        ) : null}
                                    </div>

                                    <div className="col-md-6 col-12 mt-3">
                                        <label htmlFor="">Your Area </label>
                                        <input type="text" name='user_area' value={formik.values.user_area} onChange={formik.handleChange} onBlur={formik.handleBlur} className='w-100 form-control shadow-none mt-2' placeholder='Enter Your area' />
                                        {formik.touched.user_lName && formik.errors.user_area ? (
                                            <p className="text-danger">{formik.errors.user_area}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12 mt-3">
                                        <label htmlFor="">City </label>
                                        <input type="text" name='user_city' value={formik.values.user_city} onChange={formik.handleChange} onBlur={formik.handleBlur} className='w-100 form-control shadow-none mt-2' placeholder='Enter your city' />
                                        {formik.touched.user_area && formik.errors.user_city ? (
                                            <p className="text-danger">{formik.errors.user_city}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12 mt-3">
                                        <label htmlFor="">State </label>
                                        <input type="text" name='user_state' value={formik.values.user_state} onChange={formik.handleChange} onBlur={formik.handleBlur} className='w-100 form-control shadow-none mt-2' placeholder='Enter Your State' />
                                        {formik.touched.user_lName && formik.errors.user_state ? (
                                            <p className="text-danger">{formik.errors.user_state}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12 mt-3">
                                        <label htmlFor="">Country </label>

                                        <input type="text" name='user_country' value={formik.values.user_country} onChange={formik.handleChange} onBlur={formik.handleBlur} className='w-100 form-control shadow-none mt-2' placeholder='Enter Your Country' />
                                        {formik.touched.user_country && formik.errors.user_country ? (
                                            <p className="text-danger">{formik.errors.user_country}</p>
                                        ) : null}
                                    </div>
                                    {/* <div className="col-md-6 col-12 mt-3">
                                        <label htmlFor="">Role </label>
                                        <select id="role" name="role" value={formik.values.role} onChange={formik.handleChange} onBlur={formik.handleBlur} className='w-100 p-2 mt-2 form-control shadow-none' >
                                            <option value="">Select Role</option>
                                            <option value="user">user</option>
                                            <option value="user">user</option>
                                        </select>
                                        {formik.touched.role && formik.errors.role ? (
                                            <p className="text-danger">{formik.errors.role}</p>
                                        ) : null}
                                    </div> */}

                                    <div className="remember-forgot d-flex align-items-center mt-4">
                                        <div className="remember-me">
                                            <input className="form-check-input" type="checkbox" value="" id="invalidCheck" required />
                                            <label className="form-check-label ms-3" htmlFor="invalidCheck">
                                                Agree to terms and conditions
                                            </label>
                                        </div>
                                    </div>

                                    <div className='d-flex justify-content-center'>
                                        <button type="submit" className='submit-btn w-25 mt-4 text-white rounded py-2'>Submit</button>
                                    </div>

                                    <div className="divider d-flex align-items-center my-4 py-0">
                                        <span className='fs-6 px-4'>Or Continue With</span>
                                    </div>

                                    <div className="form-social d-inline-flex justify-content-center">
                                        <div>
                                            <FaFacebook className="icon fs-3" />

                                            <GoogleLoginButton />


                                            <FaTwitter className="icon ms-4 fs-3" />
                                        </div>
                                    </div>
                                    <div className="signup-link d-inline-flex justify-content-center mt-3">
                                        <p>Already have an account? <Link to={'/user/userLogin'} className='font-weight-bold text-black text-decoration-none'>Sign In</Link></p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default UserRegister;